module.exports = __webpack_public_path__ + "img/dsh.9ef3cc77.svg";